import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'riskAssessmentId',
                              },
                              '!when': '2025-04-04',
                              '!perf_location': {
                                '??': [
                                  {
                                    '@$': 'perfLocation',
                                  },
                                  false,
                                ],
                              },
                              '!sub_scope_work': {
                                '??': [
                                  {
                                    '@$': 'subScopeWork',
                                  },
                                  false,
                                ],
                              },
                              '!special_subjects': {
                                '??': [
                                  {
                                    '@$': 'specialSubjects',
                                  },
                                  false,
                                ],
                              },
                              '!sub_award_pct': {
                                '??': [
                                  {
                                    '@$': 'subAwardPct',
                                  },
                                  false,
                                ],
                              },
                              '!subj#!subaward': {
                                '@$': 'subawardId',
                              },
                              '!out_funds_amt': {
                                '??': [
                                  {
                                    '@$': 'outFundsAmt',
                                  },
                                  false,
                                ],
                              },
                              '!prime_award_type': {
                                '??': [
                                  {
                                    '@$': 'primeAwardType',
                                  },
                                  false,
                                ],
                              },
                              '!prime_sponsor_type': {
                                '??': [
                                  {
                                    '@$': 'primeSponsorType',
                                  },
                                  false,
                                ],
                              },
                              '!other_risks_found': {
                                '??': [
                                  {
                                    '@$': 'otherRisksFound',
                                  },
                                  false,
                                ],
                              },
                              '!fed_award_exp': {
                                '??': [
                                  {
                                    '@$': 'fedAwardExp',
                                  },
                                  false,
                                ],
                              },
                              '!participant_support': {
                                '??': [
                                  {
                                    '@$': 'participantSupport',
                                  },
                                  false,
                                ],
                              },
                              '!cost_share_included': {
                                '??': [
                                  {
                                    '@$': 'costShareIncluded',
                                  },
                                  false,
                                ],
                              },
                              '!itar_ear_conflict': {
                                '??': [
                                  {
                                    '@$': 'itarEarConflict',
                                  },
                                  false,
                                ],
                              },
                              '!pte_audit_decision': {
                                '??': [
                                  {
                                    '@$': 'pteAuditDecision',
                                  },
                                  false,
                                ],
                              },
                              '!pi_debar_suspend': {
                                '??': [
                                  {
                                    '@$': 'piDebarSuspend',
                                  },
                                  false,
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              modelId: 'snap:!subawards:!subaward_risk_survey',
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
